export const TipoContratosEnum = Object.freeze({
    "Régimen General": 1,
    "Domésticas": 2,
});
